"use client"

import axios from "axios"
import { useEffect, useState } from "react"
import DatePicker from "react-datepicker"
import { NotificationManager } from "react-notifications"
import dollar from "../../../assets/icons/dollar.svg"
import percentage from "../../../assets/icons/percentage.svg"
import SearchDropdown from "../../../components/Dropdowns/SearchDropdown"
import InputWithIcon from "../../../components/InputWithIcon"
import useAuth from "../../../hooks/useAuth"
import { BASE_URL } from "../../../utils/Element"

const AddExecutedData = ({
  addexecutedData,
  handleSubmit,
  isSidebarOpen,
  setExecutedData,
  handleChange,
  onClose,
  disable,
  error,
  onSetError,
  isDollar,
  setIsDollar,
  isContractCapRateDollar,
  setIsContractCapRateDollar,
  isSellerBDSDollar,
  setIsSellerBDSDollar,
  isBuyerBDSDollar,
  setIsBuyerBDSDollar,
  isSellerBrokerDollar,
  setIsSellerBrokerDollar,
  isBuyerBrokerDollar,
  setIsBuyerBrokerDollar,
  isEditMode = false,
}) => {
  const [config] = useAuth()
  const [propertyOptions, setPropertyOptions] = useState([])

  const fetchPropertySuggestions = (inputValue) => {
    const isPortfolio = addexecutedData?.portfolio === 1
    axios
      .get(`${BASE_URL}/get-datalisting?list=offer&search=${inputValue}&portfolio=${isPortfolio ? 1 : 0}`, config)
      .then((res) => {
        const data = res.data.offer
        const options = data.map((el) => ({
          value: el.id,
          label: el?.link?.property_name,
          desc: `${el?.link?.street_address}, ${el?.link?.city}, ${el?.link?.state}`,
          offer_id: el.id,
          property: {
            id: el?.link?.id,
            name: el?.link?.property_name,
          },
        }))
        setPropertyOptions(options)
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message)
        }
      })
  }

  useEffect(() => {
    if (isSidebarOpen) {
      fetchPropertySuggestions("")
    }
  }, [isSidebarOpen, addexecutedData?.portfolio])

  const handlePortfolioChange = () => {
    const portfolioStatus = addexecutedData.portfolio === 1 ? 0 : 1
    setExecutedData({
      ...addexecutedData,
      portfolio: portfolioStatus,
      property: { id: "", name: "" },
    })
  }

  return (
    <div>
      <form className="contact-form" onSubmit={handleSubmit}>
        {/* Existing fields unchanged */}
        <div className="mt-6">
          <label className="dark-H head-4 mb-2">Executed LOI Date</label>
          <DatePicker
            className="body-N"
            dateFormat="MM/dd/yyyy"
            placeholderText="MM/DD/YYYY"
            selected={addexecutedData.created_at ? new Date(addexecutedData.created_at) : null}
            onChange={(value) => {
              onSetError({ ...error, created_at: "" })
              handleChange(value, "created_at")
            }}
          />
          {error?.created_at && <p className="body-S red-D">{error?.created_at}</p>}
        </div>

        <div className="mt-6">
          <label className="container" style={{ marginBottom: "0px" }}>
            <p style={{ paddingLeft: "30px" }} className="dark-H head-4">
              Portfolio
            </p>
            <input
              type="checkbox"
              checked={!!addexecutedData?.portfolio}
              className="body-N"
              onChange={handlePortfolioChange}
            />
            <span className="checkmark"></span>
          </label>
        </div>

        <div className="mt-6">
          <label className="dark-H head-4 mb-2">Property Name</label>
          <SearchDropdown
            placeholder="search Property here"
            text={addexecutedData?.property?.name}
            options={propertyOptions}
            fetchSuggestions={fetchPropertySuggestions}
            onSetOptions={(value) => setPropertyOptions(value)}
            handleSelect={(option) => {
              setExecutedData({
                ...addexecutedData,
                offer_id: option?.value,
                property: { id: option?.value, name: option?.label },
              })
              setPropertyOptions([])
            }}
          />
          {error?.property_name && <p className="body-S red-D pt-1">{error?.property_name}</p>}
        </div>

        <div className="mt-6">
          <label className="dark-H head-4 mb-2">Contract Price</label>
          <InputWithIcon
            icon={dollar}
            className="body-N"
            name="contract_price"
            type="number"
            placeholder="Write Contract Price Here"
            value={addexecutedData.contract_price || ""}
            onChange={(e) => handleChange(e.target.value, "contract_price")}
          />
          {error?.contract_price && <p className="body-S red-D pt-1">{error?.contract_price}</p>}
        </div>

        <div className="mt-6">
          <div className="flex justify-between gap-2">
            <label className="dark-H head-4 mb-2">Contract Cap Rate</label>
          </div>
          <InputWithIcon
            icon={percentage}
            className="body-N"
            name="contract_cap_rate"
            type="number"
            placeholder="Write Contract Cap Rate Here"
            value={addexecutedData.contract_cap_rate || ""}
            onChange={(e) => handleChange(e.target.value, "contract_cap_rate")}
          />
          {error?.contract_cap_rate && <p className="body-S red-D pt-1">{error?.contract_cap_rate}</p>}
        </div>

        <div className="mt-6">
          <div className="flex justify-between gap-2">
            <label className="dark-H head-4 mb-2">GCI To Company</label>
            <button
              type="button"
              onClick={() => setIsDollar(!isDollar)}
              className="px-3 py-1 text-sm border rounded-lg bg-gray-100 hover:bg-gray-200"
            >
              {isDollar ? "%" : "$"}
            </button>
          </div>
          <InputWithIcon
            icon={isDollar ? dollar : percentage}
            className="body-N"
            name="company_gcl"
            type="number"
            placeholder="Write GCI To Company"
            value={addexecutedData.company_gcl || ""}
            onChange={(e) => handleChange(e.target.value, "company_gcl")}
          />
          {error?.company_gcl && <p className="body-S red-D pt-1">{error?.company_gcl}</p>}
        </div>

        {/* Seller BDS - Disabled in Edit Mode */}
        {/* <div className="mt-6">
          <div className="flex justify-between gap-2">
            <label className="dark-H head-4 mb-2">Seller BDS</label>
            {!isEditMode && (
              <button
                type="button"
                onClick={() => setIsSellerBDSDollar(!isSellerBDSDollar)}
                className="px-3 py-1 text-sm border rounded-lg bg-gray-100 hover:bg-gray-200"
              >
                {isSellerBDSDollar ? "%" : "$"}
              </button>
            )}
          </div>
          <div className={isEditMode ? "opacity-60 pointer-events-none" : ""}>
            <InputWithIcon
              icon={isSellerBDSDollar ? dollar : percentage}
              className="body-N"
              name="gcl_broker_representing_seller"
              type="number"
              placeholder="Write Seller BDS"
              value={addexecutedData.gcl_broker_representing_seller || ""}
              onChange={(e) => handleChange(e.target.value, "gcl_broker_representing_seller")}
              disabled={isEditMode} // Passed in case InputWithIcon supports it later
            />
          </div>
          {error?.gcl_broker_representing_seller && (
            <p className="body-S red-D pt-1">{error?.gcl_broker_representing_seller}</p>
          )}
        </div> */}

        {/* Buyer BDS - Disabled in Edit Mode */}
        {/* <div className="mt-6">
          <div className="flex justify-between gap-2">
            <label className="dark-H head-4 mb-2">Buyer BDS</label>
            {!isEditMode && (
              <button
                type="button"
                onClick={() => setIsBuyerBDSDollar(!isBuyerBDSDollar)}
                className="px-3 py-1 text-sm border rounded-lg bg-gray-100 hover:bg-gray-200"
              >
                {isBuyerBDSDollar ? "%" : "$"}
              </button>
            )}
          </div>
          <div className={isEditMode ? "opacity-60 pointer-events-none" : ""}>
            <InputWithIcon
              icon={isBuyerBDSDollar ? dollar : percentage}
              className="body-N"
              name="gcl_broker_representing_buyer"
              type="number"
              placeholder="Write Buyer BDS"
              value={addexecutedData.gcl_broker_representing_buyer || ""}
              onChange={(e) => handleChange(e.target.value, "gcl_broker_representing_buyer")}
              disabled={isEditMode}
            />
          </div>
          {error?.gcl_broker_representing_buyer && (
            <p className="body-S red-D pt-1">{error?.gcl_broker_representing_buyer}</p>
          )}
        </div> */}

        {/* Total Seller Broker - Disabled in Edit Mode */}
        {/* <div className="mt-6">
          <div className="flex justify-between gap-2">
            <label className="dark-H head-4 mb-2">Total Seller Broker</label>
            {!isEditMode && (
              <button
                type="button"
                onClick={() => setIsSellerBrokerDollar(!isSellerBrokerDollar)}
                className="px-3 py-1 text-sm border rounded-lg bg-gray-100 hover:bg-gray-200"
              >
                {isSellerBrokerDollar ? "%" : "$"}
              </button>
            )}
          </div>
          <div className={isEditMode ? "opacity-60 pointer-events-none" : ""}>
            <InputWithIcon
              icon={isSellerBrokerDollar ? dollar : percentage}
              className="body-N"
              name="gcl_bds_seller"
              type="number"
              placeholder="Write Seller Broker"
              value={addexecutedData.gcl_bds_seller || ""}
              onChange={(e) => handleChange(e.target.value, "gcl_bds_seller")}
              disabled={isEditMode}
            />
          </div>
          {error?.gcl_bds_seller && <p className="body-S red-D pt-1">{error?.gcl_bds_seller}</p>}
        </div> */}

        {/* Seller Broker Shares - Remains editable */}
        {/* {addexecutedData?.gcl_broker_seller_share?.length > 0 && (
          <div className="mt-8">
            <h3 className="dark-H head-4 mb-3">Seller Broker share</h3>
            {addexecutedData.gcl_broker_seller_share.map((item, index) => (
              <div key={index} className="mb-4 border rounded-lg p-3 bg-gray-50 dark:bg-gray-800">
                <div className="flex justify-between items-center mb-2">
                  <p className="dark-H head-5">{item.name}</p>
                  <button
                    type="button"
                    onClick={() => {
                      const updated = [...addexecutedData.gcl_broker_seller_share]
                      updated[index].isDollar = !updated[index].isDollar
                      setExecutedData({ ...addexecutedData, gcl_broker_seller_share: updated })
                    }}
                    className="px-3 py-1 text-sm border rounded-lg bg-gray-100 hover:bg-gray-200"
                  >
                    {item.isDollar ? "$" : "%"}
                  </button>
                </div>
                <InputWithIcon
                  icon={item.isDollar ? dollar : percentage}
                  className="body-N"
                  type="number"
                  placeholder={`Enter ${item.isDollar ? "Dollar" : "Percent"}`}
                  value={item.percent || ""}
                  onChange={(e) => {
                    const updated = [...addexecutedData.gcl_broker_seller_share]
                    updated[index].percent = e.target.value
                    setExecutedData({ ...addexecutedData, gcl_broker_seller_share: updated })
                  }}
                />
              </div>
            ))}
          </div>
        )} */}

        {/* Total Buyer Broker - Disabled in Edit Mode */}
        {/* <div className="mt-6">
          <div className="flex justify-between gap-2">
            <label className="dark-H head-4 mb-2">Total Buyer Broker</label>
            {!isEditMode && (
              <button
                type="button"
                onClick={() => setIsBuyerBrokerDollar(!isBuyerBrokerDollar)}
                className="px-3 py-1 text-sm border rounded-lg bg-gray-100 hover:bg-gray-200"
              >
                {isBuyerBrokerDollar ? "%" : "$"}
              </button>
            )}
          </div>
          <div className={isEditMode ? "opacity-60 pointer-events-none" : ""}>
            <InputWithIcon
              icon={isBuyerBrokerDollar ? dollar : percentage}
              className="body-N"
              name="gcl_bds_buyer"
              type="number"
              placeholder="Write Buyer Broker"
              value={addexecutedData.gcl_bds_buyer || ""}
              onChange={(e) => handleChange(e.target.value, "gcl_bds_buyer")}
              disabled={isEditMode}
            />
          </div>
          {error?.gcl_bds_buyer && <p className="body-S red-D pt-1">{error?.gcl_bds_buyer}</p>}
        </div> */}

        {/* Buyer Broker Shares - Remains editable */}
        {/* {addexecutedData?.gcl_broker_buyer_share?.length > 0 && (
          <div className="mt-8">
            <h3 className="dark-H head-4 mb-3">Buyer Broker share</h3>
            {addexecutedData.gcl_broker_buyer_share.map((item, index) => (
              <div key={index} className="mb-4 border rounded-lg p-3 bg-gray-50 dark:bg-gray-800">
                <div className="flex justify-between items-center mb-2">
                  <p className="dark-H head-5">{item.name}</p>
                  <button
                    type="button"
                    onClick={() => {
                      const updated = [...addexecutedData.gcl_broker_buyer_share]
                      updated[index].isDollar = !updated[index].isDollar
                      setExecutedData({ ...addexecutedData, gcl_broker_buyer_share: updated })
                    }}
                    className="px-3 py-1 text-sm border rounded-lg bg-gray-100 hover:bg-gray-200"
                  >
                    {item.isDollar ? "$" : "%"}
                  </button>
                </div>
                <InputWithIcon
                  icon={item.isDollar ? dollar : percentage}
                  className="body-N"
                  type="number"
                  placeholder={`Enter ${item.isDollar ? "Dollar" : "Percent"}`}
                  value={item.percent || ""}
                  onChange={(e) => {
                    const updated = [...addexecutedData.gcl_broker_buyer_share]
                    updated[index].percent = e.target.value
                    setExecutedData({ ...addexecutedData, gcl_broker_buyer_share: updated })
                  }}
                />
              </div>
            ))}
          </div>
        )} */}

        <div className="mt-6">
          <button type="submit" disabled={disable} className="save-button light-L head-5 green-bg-H">
            Save
          </button>
          <button type="button" onClick={onClose} className="green-H ml-5">
            Cancel
          </button>
        </div>
      </form>
    </div>
  )
}

export default AddExecutedData